// export const url = 'http://localhost:1337';
export const url = 'https://avtal.expoavenue.se/api';
